<template>
  <div class="base-empty-result">
    <NuxtImg
      class="image"
      :src="imageSrc"
      :alt="title"
      format="webp"
      :width="imageSize.width"
      :height="imageSize.height"
    />
    <div class="text-content">
      <h3 class="title">{{ title }}</h3>
      <p class="description">{{ description }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const props = withDefaults(
    defineProps<{
      image?: 'not-found' | 'hats'
      title?: string
      description?: string
    }>(),
    {
      image: 'not-found',
      title: 'По запросу ничего не найдено',
      description: 'Попробуйте ввести другие параметры',
    }
  )

  const IMAGE_SIZES = {
    'not-found': { width: 333, height: 234 },
    'hats': { width: 329, height: 280 },
  } as const

  const imageSrc = computed(() => `/not-found/${props.image}.png`)
  const imageSize = computed(() => IMAGE_SIZES[props.image])
</script>

<style lang="scss" scoped>
  .base-empty-result {
    @extend %flex-column;

    align-items: center;
    justify-content: center;
    gap: 16px;
    width: 100%;
    padding: 64px 16px;

    @include vp-767 {
      padding: 32px 16px;
    }

    > .image {
      max-width: 100%;
      height: auto;
    }

    > .text-content {
      @extend %flex-column;

      gap: 12px;
      text-align: center;
      max-width: 520px;

      > .title {
        font-weight: 500;
        font-size: 24px;
        line-height: 32px;
        color: $color-default-black;
        margin: 0;

        @include vp-767 {
          font-size: 20px;
          line-height: 28px;
        }
      }

      > .description {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: $color-potato-50;
        margin: 0;

        @include vp-767 {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
</style>
